import {translation} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import React, {JSX, memo, useMemo} from "react";
import {Attachments} from "../Attachments";
import {DriverResult} from "../types/DriverResult";
import AttachmentsComponent from "./AttachmentsComponent";
import ExpiredAttachmentsComponent from "./ExpiredAttachmentsComponent";

export type DriverComponentProps = {
	driver: DriverResult;
	filesPrefix: string;
}

function DriverComponent({driver, filesPrefix}: DriverComponentProps): JSX.Element {
	const expired = useMemo(() => Attachments.findExpired(driver), [driver]);

	return (
		<div className="card card--driver">
			<div className="columns gap padded">
				<dl className="title-desc col50">
					<dt>{translation(PermitTranslations.driver__full_name)}</dt>
					<dd>{driver.fullName}</dd>
				</dl>
				{driver.licenseNumber && <dl className="title-desc col50">
                    <dt>{translation(PermitTranslations.driver__license_number)}</dt>
                    <dd>{driver.licenseNumber}</dd>
                </dl>}
				<AttachmentsComponent entity={driver} linkPrefix={filesPrefix} className="col100"/>
				<ExpiredAttachmentsComponent attachments={expired} linkPrefix={filesPrefix} className="col100"/>
			</div>
		</div>
	);
}

const MemoizedDriverComponent: React.FC<DriverComponentProps> = memo(DriverComponent);
export default MemoizedDriverComponent;
